<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer002">
<h1 class="Hidden-Title"><a id="_idTextAnchor000"></a>Title Page</h1>
<div class="logo"><img alt="" src="image/C&amp;D_logo.jpg"/></div>
<p class="presents">presents</p>
<p class="Iconic-Cars">Iconic Cars</p>
<p class="main_title">Porsche</p>
<div class="logo"><img alt="" class="_idGenObjectAttribute-1" src="image/RosettaBooks_Logo.jpg"/></div>
<p class="publisher_city">New York 2015</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Porsche__1__TP.vue?420bd4e3